import { zodValidator } from '@tanstack/zod-adapter';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AuditLogPage } from '../features/manage/audit-log-page';
const SearchSchema = z.object({
  action: z
    .string()
    .regex(/^[a-z0-9_.]{1,100}$/u)
    .optional()
    .catch(undefined),
  page: z.number().int().positive().catch(1),
  pageSize: z.union([z.literal(10), z.literal(25), z.literal(50), z.literal(100)]).catch(25),
  q: z.string().trim().max(200).optional().catch(undefined),
  resourceType: z
    .string()
    .regex(/^[A-Za-z]{1,60}$/u)
    .optional()
    .catch(undefined),
  range: z.enum(['7d', '30d', '90d']).optional().catch(undefined),
});
export const Route = createFileRoute('/manage/$companySlug/settings/audit-log')({
  component: RouteComponent,
  validateSearch: zodValidator(SearchSchema),
});
function RouteComponent() {
  const { companySlug } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <AuditLogPage
      companySlug={companySlug}
      // A new filter always returns to the first page: the old page may not exist any more.
      onFiltersChange={(change) =>
        void navigate({ search: (previous) => ({ ...previous, ...change, page: 1 }) })
      }
      onPageChange={(page) => void navigate({ search: (previous) => ({ ...previous, page }) })}
      searchState={search}
    />
  );
}
